import { styled } from '@material-ui/core/styles';

import WhoWeAreLegsImg from '../../../img/who-we-are-legs.png';

export const Container = styled('div')(({ theme }) => ({
  height: '80vh',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'minmax(100px, auto) 640px 640px minmax(100px, auto)',
  gridTemplateAreas: `"image image info ."`,
  [theme.breakpoints.down('1367')]: {
    gridTemplateColumns: 'minmax(100px, auto) 600px 600px minmax(100px, auto)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'minmax(100px, auto) 330px 540px minmax(100px, auto)',
  },
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column-reverse',
    '& > .back-image': {
      height: '45%',
      width: '100%',
      background: `linear-gradient(180deg, ${theme.palette.primary.main}, transparent)`,
    },
  },
  [theme.breakpoints.down('xs')]: {
    height: '100%',
  },
}));

export const Image = styled('div')(({ theme }) => ({
  height: '74%',
  width: '100%',
  background: `url("${WhoWeAreLegsImg}") no-repeat center`,
  backgroundSize: 'cover',
  borderRadius: '20px',
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  gridArea: 'image',
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    height: '45%',
    width: '100%',
    borderRadius: '50px',
  },
}));

export const BackgroundGreen = styled('div')(({ theme }) => ({
  height: '56%',
  width: '100%',
  background: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const Info = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexDirection: 'column',
  color: theme.palette.background.default,
  gridArea: 'info',
  '& span': {
    fontWeight: '400',
  },
  '& p': {
    marginBlockStart: '0.4em',
    marginBlockEnd: '0.4em',
  },
  [theme.breakpoints.down('xl')]: {
    paddingLeft: '5rem',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '0 0 0 6rem',
  },
  [theme.breakpoints.down('md')]: {
    height: '100%',
    width: '90%',
    alignItems: 'center',
    paddingBottom: '10rem',
    paddingTop: '12rem',
    paddingLeft: '0em',
    paddingRight: '0rem',
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    height: '100%',
    alignItems: 'center',
    paddingBottom: '10rem',
    paddingTop: '12rem',
    textAlign: 'center',
  },
}));

export const Divider = styled('hr')(() => ({
  width: '10%',
  margin: '10px 5px',
  border: '1px solid #fff',
}));
